const uzbek = {
  navbarTitle1: "Home",
  navbarTitle2: "Xizmatlar",
  navbarTitle3: "Narxlar",
  navbarTitle4: "Mijozlar",
  navbarTitle5: "Biz Haqimizda",
  navbarTitle6: "Aloqa",
  // hero page
  homeHeaderTitle1: "Marketing Yechimlari",
  homeHeaderTitle2: "biz bilan",
  homeHeaderFormTitle: "Biz bilan Bog'laning",
  homeHeaderInputTitle: "Ism",
  homeHeaderInputTitle1: "Telefon raqam",
  homeHeaderInputTitle2: "Elektron Manzil",
  homeHeaderInputTitle3: "Hizmat turi",
  homeButton: "Boshlash",
  homeFormAlertTitle1: "Ismingizni yozing!",
  homeFormAlertTitle2: "Telefon raqamingizni yozing!",
  homeFormAlertTitle3: "Ismingiz Eng kamida 4 belgidan iborat bo'lishi kerak!",
  homeFormAlertTitle4: "Telefon  Eng kamida 12 belgidan iborat bo'lishi kerak!",
  // our service page
  ourServiceTitle: "Marketing Yechimlari",
  ourServiceSubtitle: "",
  ourServiceCardText1: "",
  ourServiceCardText2: "",
  ourServiceCardText3: "",
  ourServiceCardText4: "",
};

export default uzbek;
